import React, { forwardRef, useImperativeHandle, useState } from 'react';
import s from '../../styles/AdminDocumentMap.module.css';

export interface AddRowProps {
  onAdd: (name: string, value_type: string, required: boolean, viewingRole: string, edittingRole: string) => Promise<void>;
}

export interface AddFieldTypeRowHandle {
  open: () => void;
}

const AddFieldTypeRow = forwardRef<AddFieldTypeRowHandle, AddRowProps>(({ onAdd }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');
  const [valueType, setValueType] = useState('string');
  const [required, setRequired] = useState(false);
  const [viewingRole, setViewingRole] = useState('');
  const [edittingRole, setEdittingRole] = useState('');
  const [saving, setSaving] = useState(false);

  useImperativeHandle(ref, () => ({ open: () => setIsOpen(true) }));

  const close = () => { setValue(''); setValueType('string'); setRequired(false); setViewingRole(''); setEdittingRole(''); setIsOpen(false); };

  const submit = async () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    setSaving(true);
    await onAdd(trimmed, valueType, required, viewingRole, edittingRole);
    setSaving(false);
    close();
  };

  if (!isOpen) return null;
  return (
    <div className={s.modalOverlay} onClick={close}>
      <div className={s.modal} onClick={e => e.stopPropagation()}>
        <p className={s.modalTitle}>Add Field Type</p>

        <div className={s.modalField}>
          <label className={s.modalLabel}>Field Name</label>
          <input
            className={s.modalInput}
            placeholder="Enter field name..."
            value={value}
            onChange={e => setValue(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') submit(); if (e.key === 'Escape') close(); }}
            autoFocus
          />
        </div>

        <div className={s.modalField}>
          <label className={s.modalLabel}>Type</label>
          <select
            className={s.modalSelect}
            value={valueType}
            onChange={e => setValueType(e.target.value)}
          >
            <option value="string">Text</option>
            <option value="boolean">Boolean</option>
            <option value="date">Date</option>
          </select>
        </div>

        <div className={s.modalField}>
          <label className={s.modalLabel}>Required</label>
          <label className={s.modalCheckboxRow}>
            <input
              type="checkbox"
              checked={required}
              onChange={e => setRequired(e.target.checked)}
            />
            This field is required
          </label>
        </div>

        <div className={s.modalField}>
          <label className={s.modalLabel}>Viewing Role</label>
          <select
            className={s.modalSelect}
            value={viewingRole}
            onChange={e => setViewingRole(e.target.value)}
          >
            <option value="">Select role...</option>
            <option value="agent">Agent</option>
            <option value="manager">Manager</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <div className={s.modalField}>
          <label className={s.modalLabel}>Editing Role</label>
          <select
            className={s.modalSelect}
            value={edittingRole}
            onChange={e => setEdittingRole(e.target.value)}
          >
            <option value="">Select role...</option>
            <option value="agent">Agent</option>
            <option value="manager">Manager</option>
            <option value="aadmin">Admin</option>
          </select>
        </div>

        <div className={s.modalActions}>
          <button className={`${s.btnSm} ${s.btnSecondary}`} onClick={close}>Cancel</button>
          <button className={`${s.btnSm} ${s.btnPrimary}`} onClick={submit} disabled={saving || !value.trim() || !viewingRole || !edittingRole}>
            {saving ? '…' : 'Add Field Type'}
          </button>
        </div>
      </div>
    </div>
  );
});

AddFieldTypeRow.displayName = 'AddFieldTypeRow';
export default AddFieldTypeRow;